import { render, staticRenderFns } from "./ListTaxiCompany.vue?vue&type=template&id=5fd36d40&"
import script from "./ListTaxiCompany.vue?vue&type=script&lang=js&"
export * from "./ListTaxiCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports